<template>
  <div class="header" :class="{ 'is-iframe': isInIframe }">
    <div class="no-content" >
        <img src="@/assets/icons/logo3.png" alt="泛亚人力" class="logo_img" />
    </div>
    <div class="center-user">
      <!-- <user /> -->
      <company />
    </div>
    <div class="right-container">
      <customer-service />
      <notice />
      <out/>
    </div>
  </div>
</template>

<script>
// import Search from "@/components/header/Search.vue";
import CustomerService from "@/components/header/CustomerService.vue";
import Notice from "@/components/header/Notice.vue";
import company from "@/components/header/company.vue";
// import User from "@/components/header/User.vue";
import Out from './out.vue';
export default {
  components: {
    // Search,
    CustomerService,
    Notice,
    company,
    // User,
    Out
  },
  data() {
    return {};
  },
  computed: {
    isInIframe() {
      try {
        return window.parent !== window;
      } catch (e) {
        return true;
      }
    }
  },
  methods: {}
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background-color: #409EFE;
  border-bottom: 1px solid #409EFE;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 70px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  white-space: nowrap;
}

.header.is-iframe {
  /* position: sticky;
  top: 0;
  z-index: 1; */
}

.header::-webkit-scrollbar {
  display: none;
}

.no-content {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.logo_img {
  width: clamp(7rem, 8vw, 8rem); /* 112px-128px */
  height: clamp(3rem, 4vw, 3.5rem); /* 48px-56px */
  object-fit: contain;
}

.center-user {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  min-width: 150px;
  overflow: hidden;
  margin-right: 40px;
  > * {
    flex-shrink: 1;
    min-width: 0;
  }
}
.right-container {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
  > * {
    margin-left: 80px;
    flex-shrink: 1;
    min-width: 0;
  }
  > *:first-child {
    margin-left: 0;
  }
  
  @media screen and (max-width: 1200px) {
    > * {
      margin-left: 40px;
    }
  }
  
  @media screen and (max-width: 992px) {
    > * {
      margin-left: 24px;
    }
  }
  
  @media screen and (max-width: 768px) {
    > * {
      margin-left: 16px;
    }
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .center-user {
    margin-right: 20px;
  }
}
.button-a.el-button {
  margin-left: 32px;
  padding: 14px 20px;
}
</style>